import { lazy, Suspense, ReactElement } from 'react';
import PageLoadingScreen from '@/components/PageLoadingScreen';

interface Props {
    componentPath?: string;
    element?: ReactElement;
}

const LazyRouteElement = ({ componentPath, element }: Props) => {
    let Comp;
    if (!!componentPath) {
        const to = `../pages/${componentPath}`;
        Comp = lazy(() => import(/* @vite-ignore */ to).then((module) => module));
    }

    const children = element || <div>No Page</div>;

    return (
        <Suspense fallback={<PageLoadingScreen isLoading={true} message={'Loading...'} />}>
            {!!Comp ? <Comp /> : children}
        </Suspense>
    );
};

export default LazyRouteElement;
